import { Stack, Image, Text } from '@chakra-ui/react';
import { FC } from 'react';
import Logo from '@resources/images/logo-gattinoni.png';

const FooterComponent: FC = () => {
    return (
        <Stack
            paddingX="50px"
            paddingY="30px"
            alignSelf="stretch"
            direction="row"
            justify="flex-start"
            align="center"
            spacing="20px"
            background="#000"
        >
            <Image width="115.38px" height="30px" src={Logo} />
            <Text variant="normal" color="white" flex="1" textAlign="end">
                Copyright © Gattinoni Travel Network s.r.l. All rights reserved
            </Text>
        </Stack>
    );
};

export default FooterComponent;
